import { regionCodes } from '../../referenceData';
import isCustomGroup from '../isCustomGroup';

export default function isRegularGroup(code) {
  if (!code) return false;
  if (isCustomGroup(code)) return false;
  return regionCodes.includes(code);
}
